// extracted by mini-css-extract-plugin
export var actions = "_sj-4";
export var item = "_sj-1";
export var price = "_sj-3";
export var quantity = "_sj-2";
export var table = "_sj-0";